export interface JsonWebToken {
  /** Can update profile  */
  can_update: boolean,
  
  /** Email address. */
  email: string,

  /** Expiry date time, in epoch. */
  exp: number,

  /** Original iat (issued at) date time, in epoch. */
  orig_iat: number,

  /** User ID. */
  user_id: string | number,

  /** First name */
  first_name: string,

  /** Last name */
  last_name: string,

  /** If user is mentor */
  is_mentor: boolean
}

export enum DataLoadStatus {
  /** Request has not been sent. */
  NOT_STARTED,

  /** Request has been sent and waiting server response. */
  LOADING,

  /** Response received and successful. */
  LOADED,

  /** Request failed or response is invalid . */
  FAILED
}



// WEBPACK FOOTER //
// ./src/types/shared.ts